import React, { useState } from 'react';
import { Button, Spinner, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';
import { settings } from '../../settings';

export default function DGLTH_supplier_invoices_received({ item, entity = null, refreshData }) {

    const [xmlLoading, setXmlLoading] = useState(false);
    const [respondLoading, setRespondLoading] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectDescription, setRejectDescription] = useState('');

    async function downloadXml() {
        if (xmlLoading) return;
        setXmlLoading(true);
        try {
            const res = await ApiManager.sendAuthenticatedRequest('/custom/download_received_invoice_xml', {
                idInvoice: item.id
            });
            if (res.success === 1 && res.xml) {
                const blob = new Blob(
                    [Uint8Array.from(atob(res.xml), c => c.charCodeAt(0))],
                    { type: 'application/xml' }
                );
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = res.filename || item.sdiFilename || `fattura_${item.invoiceNumber || item.id}.xml`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                toast.success('XML scaricato', { theme: 'colored' });
            } else if (res.success === 1 && res.url) {
                window.open(res.url, '_blank');
            } else {
                toast.error(res.message || 'Errore download XML', { theme: 'colored' });
            }
        } catch (err) {
            toast.error('Errore: ' + err.message, { theme: 'colored' });
        } finally {
            setXmlLoading(false);
        }
    }

    async function respondInvoice(esito, descrizione = '') {
        if (respondLoading) return;
        setRespondLoading(true);
        try {
            const res = await ApiManager.sendAuthenticatedRequest('/custom/respond_received_invoice', {
                idReceivedInvoice: item.id,
                esito: esito,
                descrizione: descrizione
            });
            if (res.success === 1) {
                toast.success(esito === 'EC01' ? 'Fattura accettata' : 'Fattura rifiutata', { theme: 'colored' });
                if (typeof refreshData === 'function') refreshData();
            } else {
                toast.error(res.message || 'Errore nella risposta', { theme: 'colored' });
            }
        } catch (err) {
            toast.error('Errore: ' + err.message, { theme: 'colored' });
        } finally {
            setRespondLoading(false);
        }
    }

    function handleAccept() {
        respondInvoice('EC01');
    }

    function handleRejectConfirm() {
        respondInvoice('EC02', rejectDescription);
        setShowRejectModal(false);
        setRejectDescription('');
    }

    const isPending = item.status?.value === 'da_elaborare' || item.status === 'da_elaborare';

    return (
        <>
            <div className='d-flex flex-row gap-1 align-items-center'>
                <Button size='sm' variant='outline-dark' onClick={downloadXml} disabled={xmlLoading}>
                    {xmlLoading ? (
                        <Spinner animation='border' size='sm' />
                    ) : (
                        <><FontAwesomeIcon icon='file-code' className='me-1' />XML</>
                    )}
                </Button>
                {settings.fatturazione && isPending && (
                    <>
                        <Button size='sm' variant='outline-success' onClick={handleAccept} disabled={respondLoading}>
                            {respondLoading ? (
                                <Spinner animation='border' size='sm' />
                            ) : (
                                <><FontAwesomeIcon icon='check' className='me-1' />Accetta</>
                            )}
                        </Button>
                        <Button size='sm' variant='outline-danger' onClick={() => setShowRejectModal(true)} disabled={respondLoading}>
                            <><FontAwesomeIcon icon='xmark' className='me-1' />Rifiuta</>
                        </Button>
                    </>
                )}
            </div>

            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Rifiuta fattura</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Motivazione (opzionale)</Form.Label>
                        <Form.Control
                            as='textarea'
                            rows={3}
                            value={rejectDescription}
                            onChange={(e) => setRejectDescription(e.target.value)}
                            placeholder='Es: Importo non corrispondente all&#39;ordine'
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowRejectModal(false)}>Annulla</Button>
                    <Button variant='danger' onClick={handleRejectConfirm} disabled={respondLoading}>
                        {respondLoading ? <Spinner animation='border' size='sm' /> : 'Conferma rifiuto'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
